<template>
  <div class="notice-list mt20">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="采购公告" name="first"> -->

    <div class="item">
      <div class="title">采购公告</div>
      <noticeItem :noticeData="noticeData1" :source="'2'"></noticeItem>
      <el-link
        :underline="false"
        type="info"
        class="notice-more"
        @click="handleViewAll('2')"
        >更多 ></el-link
      >
    </div>
    <div class="item" style="margin-left: 20px;">
      <div class="title">评标公示</div>
      <noticeItem :noticeData="noticeData2" :source="'3'"></noticeItem>
      <el-link
        :underline="false"
        type="info"
        class="notice-more"
        @click="handleViewAll('3')"
        >更多 ></el-link
      >
    </div>

    <!-- </el-tab-pane> -->
    <!-- <el-tab-pane label="评标公示" name="second">
        <noticeItem :noticeData="noticeData"></noticeItem>
      </el-tab-pane> -->
    <!-- </el-tabs> -->
  </div>
</template>

<script>
import noticeItem from "@/app/shop/components/noticeItem.vue";
import { searchPpBidNotice } from "@/app/shop/api/shopping";
export default {
  name: "noticeList",
  props: ["workDynamicsList"],
  components: {
    noticeItem
  },
  data() {
    return {
      activeName: "first",
      nodeList: [],
      agentIdEncrypt: "",
      noticeSource: "",
      noticeData1: [],
      noticeData2: []
    };
  },
  mounted() {
    this.init("first");
  },
  methods: {
    init(val) {
      searchPpBidNotice({
        searchNoticeType: "100068ZBXX",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.rows.forEach(item => {
            let time = [];
            item.noticeStartTime = item.noticeStartTime.slice(0, -3);
            console.log(time, "time");
          });
          this.noticeData1 = res.data.data.rows.slice(0, 5);
        }
      });
      searchPpBidNotice({
        searchNoticeType: "100068ZBGG",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.rows.forEach(item => {
            let time = [];
            item.noticeStartTime = item.noticeStartTime.slice(0, -3);
            console.log(time, "time");
          });
          this.noticeData2 = res.data.data.rows.slice(0, 5);
        }
      });
    },
    handleClick(e) {
      console.log(e, "e");
      this.init(e.name);
    },
    handleViewAll(source) {
      this.$router.push({
        path: "/announcementsList",
        query: {
          source: source,
          activeName: source == 3 ? this.activeName : ""
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  // margin-top: 20px;
  // padding-top: 20px;
}
.notice-list {
  position: relative;
  width: 1180px;
  display: flex;
  // background: #ffffff;
  .item {
    width: 580px;
    height: 300px;
    background: #ffffff;
    position: relative;
    .title {
      font-weight: 600;
      font-size: 20px;
      color: #4a4a4a;
      line-height: 28px;
      text-align: left;
      padding-top: 15px;
      margin: 0 0 18px 18px;
    }
    .notice-more {
      position: absolute;
      top: 17px;
      right: 20px;
      line-height: 30px;
      &:hover {
        color: #0089ef;
      }
    }
  }
}
/deep/ .el-table .cell {
  padding-left: 20px;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
/deep/.el-tabs__header {
  margin: 0 15px 0px !important;
}
/deep/ .el-tabs__item {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
}
/deep/.is-active {
  font-weight: 600 !important;
}
</style>
